/**
 * Hook to check if initial cloud sync is complete
 * Used to show loading states in components instead of "No data" messages
 *
 * @example
 * const { isSyncing } = useSyncStatus();
 * if (isSyncing) return <div>Syncing...</div>;
 */
import { useState, useEffect } from 'react';
import { useVessel } from '../contexts/VesselContext';

export const useSyncStatus = () => {
  const { currentVesselId } = useVessel();
  const [status, setStatus] = useState('syncing'); // 'syncing' | 'complete'

  useEffect(() => {
    const handleSyncStatus = (event) => {
      const { status: newStatus, vesselId } = event.detail;
      if (vesselId === currentVesselId) {
        setStatus(newStatus);
      }
    };

    window.addEventListener('sr:sync:status', handleSyncStatus);

    return () => {
      window.removeEventListener('sr:sync:status', handleSyncStatus);
    };
  }, [currentVesselId]);

  return {
    isSyncing: status === 'syncing',
    isComplete: status === 'complete'
  };
};
